import styled from 'styled-components';

export const IllustrationContent = styled.div`
  margin: 0 auto 0.5rem;
`;

export const TextContent = styled.div`
  display: grid;
  grid-gap: ${({ theme: { spacing } }) => spacing.km3};
`;

export const Actions = styled.div`
  display: grid;
  grid-gap: ${({ theme: { spacing } }) => spacing.km6};
  grid-auto-flow: column;
  justify-content: spacing-between;
  align-items: center;
`;
